import classNames from "classnames";
import { times } from "lodash";
import CheckIcon from "PFIcons/check.svg";
import PropTypes from "prop-types";
import React from "react";

import css from "./steps_dots.less";

const StepsDots = ({ ready, stepsCount, currentIndex, style }) => (
  <div className={classNames(css.root)} style={style} data-qa-id="StepsDots">
    {ready && (
      <div className={css.inner}>
        {times(stepsCount, (index) => (
          <React.Fragment key={index}>
            {index !== 0 && <div className={css.separator} />}
            <div className={css.dotCell} data-qa-id="StepsDots.Dot">
              <div
                className={classNames(css.dot, {
                  [css.dotCurrent]: index === currentIndex,
                  [css.dotDone]: index < currentIndex
                })}
              >
                {index < currentIndex ? <CheckIcon width={15} height={15} /> : <span>{index + 1}</span>}
              </div>
            </div>
          </React.Fragment>
        ))}
      </div>
    )}
  </div>
);

StepsDots.propTypes = {
  stepsCount: PropTypes.number.isRequired,
  /** count from 0 */
  currentIndex: PropTypes.number.isRequired,

  style: PropTypes.object,
  light: PropTypes.bool,
  /** if false the component still takes space (avoid jumping while loading */
  ready: PropTypes.bool
};

StepsDots.defaultProps = {
  style: null,
  light: false,
  ready: true
};

export default StepsDots;
